import React, {Component} from "react";
import {TopSelect} from "../../../../../../../../componentsTopsa/selects/TopSelects";
import TopIf from "../../../../../../../../componentsTopsa/if/TopIf";
import acc from "accounting";

export default class ZnizkaSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item:null,
            selectValue: null,
            znizki:[]
        }
        this.onChangeSelect = this.onChangeSelect.bind(this)
    }

    onChangeSelect(e) {
        this.setState({selectValue: e})
        if(e!==null){
            this.props.hangleChangeSelect(this.state.item,e.rodz,e.idPro)
        }
    }

    componentDidMount() {
        if(Boolean(this.props.rodz))
            this.setState({
                selectValue:this.props.znizki.find(z=>z.rodz===this.props.rodz),
                item:this.props.item,
                znizki:this.props.znizki,
            })
    }

    componentWillReceiveProps(nextprops) {
        if(Boolean(nextprops.rodz))
            this.setState({
                selectValue:nextprops.znizki.find(z=>z.rodz===nextprops.rodz),
                item:nextprops.item,
                znizki:nextprops.znizki,
            })
    }

    renderZnizkiOption(option) {
        return <div>
            <span className={'label label-ebus-default'} style={{color:'#fff', background:option.kolor}}>{option.rodz}</span> {option.nazZniz}
            <div className={'pull-right'}>
                <TopIf isTrue={Boolean(option.idPro)}>
                    <span style={{color: 'dodgerblue', marginRight: '7px'}}><i className={'fa fa-tags'}></i> na promocji</span>
                </TopIf>
                <span className={'label label-ebus-secondary'} style={{marginRight: '15px'}}>
                {acc.formatMoney(option.cena)}
                </span>
            </div>
        </div>
    }

    render() {
        return (
            <div>
                <TopSelect onChange={this.onChangeSelect} value={this.state.selectValue} options={this.state.znizki}
                           valueKey={'idZn'} labelKey={'nazZniz'}
                           valueRenderer={this.renderZnizkiOption}
                           optionRenderer={this.renderZnizkiOption}
                           clearable={false}
                           disabled={this.state.znizki.length===0}
                />
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/dodajBiletJednorazowy/components/definiowanieZamowienia/sekcja/components/ZnizkaSelect.js